import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

export interface ErrorSnackBarData {
  message: string;
}

@Component({
  selector: 'app-error-snack-bar',
  standalone: true,
  template: `
    <div class="flex items-center gap-3">
      <p class="m-0 flex-1 font-roboto text-sm text-white leading-5">{{ data.message }}</p>
      <button type="button" class="error-snack-close" (click)="dismiss()">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13 1L1 13M1 1l12 12" stroke="#fff" stroke-width="1.8" stroke-linecap="round"/>
        </svg>
      </button>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorSnackBarComponent {
  readonly data: ErrorSnackBarData = inject(MAT_SNACK_BAR_DATA);
  private readonly snackBarRef = inject(MatSnackBarRef<ErrorSnackBarComponent>);

  dismiss(): void { this.snackBarRef.dismiss(); }
}
